function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import { ExistWhen } from 'js/hocCollection';
const AwPanelExistWhen = ExistWhen(AwPanel);
const AwLabelExistWhen = ExistWhen(AwLabel);
AwPanelExistWhen.displayName = 'AwPanelExistWhen';
AwLabelExistWhen.displayName = 'AwLabelExistWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/popupService', () => import('js/popupService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "searchChange": {
      "actionType": "batchJob",
      "steps": [{
        "action": "doSearch"
      }, {
        "action": "updateOutputs"
      }, {
        "action": "searchResultsTableDataProviderMethod"
      }]
    },
    "updateOutputs": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "totalCount": 0,
          "facets": [],
          "searchObjects": null
        }
      },
      "deps": "js/desSearchService"
    },
    "searchResultsTableDataProviderMethod": {
      "actionType": "dataProvider",
      "method": "searchResultsTableDataProvider"
    },
    "loadData": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query searchObjects( $projectId: String, $collaborationspaceId: String, $folderId: String, $skip: Int, $searchInput: Json, $sortParams: Json) { searchObjects( projectId: $projectId, collaborationspaceId: $collaborationspaceId, folderId: $folderId, skip: $skip, searchInput: $searchInput, sortParams: $sortParams ) { error facets items totalCount skip selectedFacets }}",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "projectId": "{{props.projectid}}",
              "searchInput": {
                "category": "{{data.category}}",
                "queryString": "{{data.query}}",
                "facets": "{{data.searchFilters}}"
              },
              "sortParams": [{
                "fieldName": "name",
                "sortDirection": "ASC"
              }],
              "skip": "{{data.dataProviders.searchResultsTableDataProvider.startIndex}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "events": {
        "success": [{
          "name": "updateFacets",
          "eventData": {
            "facets": "{{data.facets}}",
            "selectedFacets": "{{data.selectedFacets}}",
            "query": "{{data.query}}"
          }
        }, {
          "condition": "totalCount",
          "name": "loadDataSuccess",
          "eventData": {
            "totalCount": "{{data.totalCount}}"
          }
        }]
      },
      "dataParsers": [{
        "id": "searchObjects",
        "responseObjs": "data.data.searchObjects.items"
      }],
      "outputData": {
        "searchObjects": "data.data.searchObjects.items",
        "totalCount": "data.data.searchObjects.totalCount",
        "facets": "data.data.searchObjects.facets",
        "selectedFacets": "data.data.searchObjects.selectedFacets",
        "dataProviders.searchResultsTableColumnProvider.columnConfig": "{{data.columnConfig}}"
      },
      "actionMessages": {},
      "deps": "js/desSearchService"
    },
    "doSearch": {
      "actionType": "JSFunction",
      "method": "search",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "category": "{{data.eventData.category}}",
          "query": "{{data.eventData.query}}",
          "searchFilters": "{{data.eventData.searchFilters}}",
          "ownership": "{{data.eventData.ownership}}"
        }
      },
      "deps": "js/desSearchService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "displayPopup": {
      "actionType": "JSFunction",
      "method": "show",
      "inputData": {
        "data": {
          "declView": "ArrangeColumns",
          "subPanelContext": {
            "columnProvider": "{{data.columnProviders.searchResultsTableColumnProvider}}",
            "dataProvider": "{{data.dataProviders.searchResultsTableDataProvider}}",
            "gridId": "searchResultsTable",
            "data": "{{data}}"
          },
          "options": {
            "preset": "modal",
            "width": "15vw",
            "clickOutsideToClose": false
          }
        }
      },
      "outputData": {
        "popupId": "id"
      },
      "deps": "js/popupService"
    },
    "hide": {
      "actionType": "JSFunctionAsync",
      "method": "hide",
      "inputData": {
        "popupEl": "{{data.popupId}}"
      },
      "deps": "js/popupService"
    },
    "setResultCount": {
      "actionType": "JSFunction",
      "method": "setResultCount",
      "inputData": {
        "data": "{{data}}",
        "totalCount": "{{parameters.totalCount}}"
      },
      "deps": "js/desSearchService"
    }
  },
  "data": {
    "columnConfig": {
      "columns": [{
        "name": "name",
        "displayName": "{{i18n.name}}",
        "minWidth": 150,
        "width": 250,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "enableColumnMoving": false,
        "visible": true
      }, {
        "name": "description",
        "displayName": "{{i18n.description}}",
        "minWidth": 115,
        "width": 115,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "owner",
        "displayName": "{{i18n.owner}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "lastModifiedDate",
        "displayName": "{{i18n.lastModifiedDate}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "creationDate",
        "displayName": "{{i18n.creationDate}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "lastModifiedBy",
        "displayName": "{{i18n.lastModifiedBy}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "revId",
        "displayName": "{{i18n.revId}}",
        "minWidth": 80,
        "width": 80,
        "enableColumnMenu": false,
        "enableColumnHiding": false,
        "enableSorting": false,
        "visible": true
      }, {
        "name": "typeName",
        "displayName": "{{i18n.typeName}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": false,
        "enableSorting": false,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "size",
        "displayName": "{{i18n.size}}",
        "minWidth": 90,
        "width": 90,
        "enableColumnMenu": false,
        "enableSorting": false,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "status",
        "displayName": "{{i18n.status}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }]
    },
    "query": "",
    "category": "",
    "facets": [],
    "searchFilters": [],
    "ownership": "anyOne",
    "searchResultCount": {
      "type": "STRING",
      "uiValue": "",
      "dbValue": "",
      "dispValue": "",
      "labelPosition": "NO_PROPERTY_LABEL"
    }
  },
  "dataParseDefinitions": {
    "searchObjects": {
      "typeIconURL": "{{response.typeIconURL}}",
      "props": {
        "name": {
          "propertyName": "name",
          "propertyDisplayName": "Name",
          "value": "{{response.name}}",
          "displayValue": "{{response.name}}",
          "uiValue": "{{response.name}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "description": {
          "propertyName": "description",
          "propertyDisplayName": "description",
          "value": "{{response.description}}",
          "displayValue": "{{response.description}}",
          "uiValue": "{{response.description}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "owner": {
          "propertyName": "owner",
          "propertyDisplayName": "owner",
          "value": "{{response.owner}}",
          "displayValue": "{{response.owner}}",
          "uiValue": "{{response.owner}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "lastModifiedDate": {
          "propertyName": "lastModifiedDate",
          "propertyDisplayName": "lastModifiedDate",
          "value": "{{response.lastModifiedDate}}",
          "displayValue": "{{response.lastModifiedDate}}",
          "uiValue": "{{response.lastModifiedDate}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "creationDate": {
          "propertyName": "creationDate",
          "propertyDisplayName": "creationDate",
          "value": "{{response.creationDate}}",
          "displayValue": "{{response.creationDate}}",
          "uiValue": "{{response.creationDate}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "lastModifiedBy": {
          "propertyName": "lastModifiedBy",
          "propertyDisplayName": "lastModifiedBy",
          "value": "{{response.lastModifiedBy}}",
          "displayValue": "{{response.lastModifiedBy}}",
          "uiValue": "{{response.lastModifiedBy}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "revId": {
          "propertyName": "revId",
          "propertyDisplayName": "revId",
          "value": "{{response.revId}}",
          "displayValue": "{{response.revId}}",
          "uiValue": "{{response.revId}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "typeName": {
          "propertyName": "typeName",
          "propertyDisplayName": "Type",
          "value": "{{response.type}}",
          "displayValue": "{{response.type}}",
          "uiValue": "{{response.type}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "size": {
          "propertyName": "size",
          "propertyDisplayName": "size",
          "value": "{{response.size}}",
          "displayValue": "{{response.size}}",
          "uiValue": "{{response.size}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        },
        "status": {
          "propertyName": "status",
          "propertyDisplayName": "status",
          "value": "{{response.status}}",
          "displayValue": "{{response.status}}",
          "uiValue": "{{response.status}}",
          "type": "STRING",
          "isEditable": false,
          "isEnabled": true
        }
      }
    }
  },
  "dataProviders": {
    "searchResultsTableDataProvider": {
      "action": "loadData",
      "response": "{{data.searchObjects}}",
      "totalFound": "{{data.totalCount}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "searchResultsTableColumnProvider": {
      "frozenColumnIndex": 1,
      "columns": [{
        "name": "name",
        "displayName": "{{i18n.name}}",
        "minWidth": 150,
        "width": 250,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "enableColumnMoving": false,
        "visible": true
      }, {
        "name": "description",
        "displayName": "{{i18n.description}}",
        "minWidth": 115,
        "width": 115,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "owner",
        "displayName": "{{i18n.owner}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "lastModifiedDate",
        "displayName": "{{i18n.lastModifiedDate}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "creationDate",
        "displayName": "{{i18n.creationDate}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "lastModifiedBy",
        "displayName": "{{i18n.lastModifiedBy}}",
        "minWidth": 150,
        "width": 200,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "revId",
        "displayName": "{{i18n.revId}}",
        "minWidth": 80,
        "width": 80,
        "enableColumnMenu": false,
        "enableColumnHiding": false,
        "enableSorting": false,
        "visible": true
      }, {
        "name": "typeName",
        "displayName": "{{i18n.typeName}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": false,
        "enableSorting": false,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "size",
        "displayName": "{{i18n.size}}",
        "minWidth": 90,
        "width": 90,
        "enableColumnMenu": false,
        "enableSorting": false,
        "enableColumnHiding": false,
        "visible": true
      }, {
        "name": "status",
        "displayName": "{{i18n.status}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": true,
        "enableColumnHiding": false,
        "visible": true
      }]
    }
  },
  "grids": {
    "searchResultsTable": {
      "dataProvider": "searchResultsTableDataProvider",
      "columnProvider": "searchResultsTableColumnProvider",
      "addIconColumn": false,
      "gridOptions": {
        "enablePinning": false,
        "enableSorting": false,
        "isFilteringEnabled": false,
        "enableGridMenu": true,
        "rowHeight": "LARGE",
        "enableDynamicRowHeight": true
      }
    }
  },
  "i18n": {
    "actions": ["projectMessages"],
    "creationDate": ["projectMessages"],
    "description": ["projectMessages"],
    "lastModifiedBy": ["projectMessages"],
    "lastModifiedDate": ["projectMessages"],
    "name": ["projectMessages"],
    "owner": ["projectMessages"],
    "revId": ["projectMessages"],
    "size": ["projectMessages"],
    "status": ["projectMessages"],
    "typeName": ["projectMessages"],
    "showing": ["projectMessages"]
  },
  "lifecycleHooks": {},
  "onEvent": [{
    "eventId": "des.search.input.changed",
    "action": "searchChange",
    "cacheEventData": true
  }, {
    "eventId": "searchResultsTableDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-search-results-as-table.selected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "des.arrange.columns.open",
    "action": "displayPopup",
    "cacheEventData": true
  }, {
    "eventId": "des.arrange.columns.checkbox.selected",
    "action": "displayPopup",
    "cacheEventData": true
  }, {
    "eventId": "des.arrange.columns.close",
    "action": "hide",
    "cacheEventData": true
  }, {
    "eventId": "loadData",
    "action": "loadData"
  }, {
    "eventId": "loadDataSuccess",
    "action": "setResultCount",
    "inputArgs": {
      "totalCount": "{{eventData.totalCount}}"
    }
  }],
  "props": {
    "collaborationspaceid": {
      "type": "string"
    },
    "accsessionid": {
      "type": "string"
    },
    "projectid": {
      "type": "string"
    },
    "commandsUrl": {
      "type": "string"
    },
    "view-path": {
      "type": "object"
    },
    "view-id": {
      "type": "string"
    }
  },
  "conditions": {
    "hasSearchValue": {
      "expression": "data.query"
    },
    "hasSearchResultCount": {
      "expression": "data.searchResultCount.dbValue"
    }
  },
  "_viewModelId": "SearchResultsTable",
  "_uniqueViewModelId": "SearchResultsTable",
  "ctx": {}
};

/*
    <aw-panel exist-when="conditions.hasSearchValue" class="aw-layout-full">
        <aw-label prop='data.searchResultCount' exist-when="conditions.hasSearchResultCount"></aw-label>
        <aw-splm-table gridid="searchResultsTable"></aw-splm-table>
    </aw-panel>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanelExistWhen, {
    revealAction: actions.reveal,
    className: "aw-layout-full",
    existWhen: AwParseService.instance("conditions.hasSearchValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwLabelExistWhen, _extends({}, getField("data.searchResultCount", fields, $index, null, null), {
    existWhen: AwParseService.instance("conditions.hasSearchResultCount")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement(AwSplmTable, grids.searchResultsTable));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;